/**
 * Lesson Progress Bar (INT-CMP-007)
 * Shows progress through lesson sections/exercises with a horizontal bar.
 */

import React from 'react';
import { View } from 'react-native';
import { Box, HStack, Text } from '@gluestack-ui/themed';
import { colors, FS_XS } from '../../theme';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

interface LessonProgressBarProps {
  current: number;
  total: number;
  /** Optional label to show alongside progress */
  label?: string;
}

export const LessonProgressBar = React.memo(function LessonProgressBar({
  current,
  total,
  label,
}: LessonProgressBarProps) {
  const { theme: t, fontScale, ffs } = useDisplayTheme();

  const progress = total > 0 ? current / total : 0;

  return (
    <Box px="$4" py="$2">
      <HStack justifyContent="space-between" alignItems="center" mb="$1">
        {label && (
          <Text
            allowFontScaling={false}
            style={{ fontSize: FS_XS * fontScale, color: t.textSecondary, ...ffs }}
          >
            {label}
          </Text>
        )}
        <Text
          allowFontScaling={false}
          style={{ fontSize: FS_XS * fontScale, color: t.textSecondary, fontWeight: '600', ...ffs }}
        >
          {current}/{total}
        </Text>
      </HStack>
      <View
        style={{
          height: 4,
          borderRadius: 2,
          backgroundColor: t.isDark ? '#374151' : '#E5E7EB',
          overflow: 'hidden',
        }}
      >
        <View
          style={{
            height: '100%',
            width: `${Math.min(progress * 100, 100)}%`,
            borderRadius: 2,
            backgroundColor: colors.primary,
          }}
        />
      </View>
    </Box>
  );
});
